import * as React from "react";
const SvgMainMenu = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 240 240"
    data-icon="1"
    {...props}
  >
    <path
      fill="none"
      stroke="#212121"
      strokeLinejoin="round"
      strokeWidth={12.00912}
      d="M15.161 14.075H67.13v51.968H15.16ZM15.161 162.608H67.13v51.969H15.16Z"
    />
    <path
      fill="#212121"
      fillRule="evenodd"
      d="M15.161 88.342H67.13v51.968H15.16Z"
    />
    <path
      fill="none"
      stroke="#212121"
      strokeLinejoin="round"
      strokeWidth={12.00912}
      d="M15.161 88.342H67.13v51.968H15.16Z"
    />
    <path
      fill="#212121"
      fillRule="evenodd"
      d="M87.175 14.075h109.37v20.031H87.175ZM87.175 42.317h158.103v20.031H87.175ZM87.175 117.506h109.37v20.031H87.175ZM87.175 88.342h158.103v20.031H87.175ZM87.175 164.455h131.032v20.031H87.175ZM87.175 192.697h158.103v20.031H87.175Z"
    />
  </svg>
);
export default SvgMainMenu;
